export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_02-end.c5e2999d.jpg";